<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
    <div class="orangehrm-horizontal-padding orangehrm-top-padding">
        <oxd-text tag="h6" class="orangehrm-main-title">{{
            $t('general.edit_skill')
        }}</oxd-text>
        <oxd-divider />
        <oxd-form :loading="isLoading" @submit-valid="onSave">
            <oxd-form-row>
                <oxd-grid :cols="3" class="orangehrm-full-width-grid">
                    <oxd-grid-item>
                        <oxd-input-field
                            v-model="skill.name"
                            :label="$t('pim.skill')"
                            required
                            readonly
                            disabled
                        />
                    </oxd-grid-item>
                    <oxd-grid-item>
                        <oxd-input-field
                            v-model="skill.yearsOfExperience"
                            :label="$t('pim.years_of_experience')"
                            :rules="rules.yearsOfExperience"
                        />
                    </oxd-grid-item>
                </oxd-grid>
            </oxd-form-row>

            <oxd-form-row>
                <oxd-grid :cols="3" class="orangehrm-full-width-grid">
                    <oxd-grid-item class="--span-column-2">
                        <oxd-input-field
                            v-model="skill.comments"
                            type="textarea"
                            :label="$t('general.comments')"
                            :rules="rules.comments"
                        />
                    </oxd-grid-item>
                </oxd-grid>
            </oxd-form-row>

            <oxd-form-actions>
                <required-text />
                <oxd-button
                    type="button"
                    display-type="ghost"
                    :label="$t('general.cancel')"
                    @click="onCancel"
                />
                <submit-button />
            </oxd-form-actions>
        </oxd-form>
        <oxd-divider />
    </div>
</template>

<script>
import {
    shouldNotExceedCharLength,
    max,
    digitsOnly,
} from '@ohrm/core/util/validation/rules';

const skillModel = {
    yearsOfExperience: 0,
    comments: '',
    name: '',
};

export default {
    name: 'EditSkill',

    props: {
        http: {
            type: Object,
            required: true,
        },
        data: {
            type: Object,
            required: true,
        },
    },

    emits: ['close'],

    data() {
        return {
            isLoading: false,
            skill: {...skillModel},
            rules: {
                yearsOfExperience: [digitsOnly, max(100)],
                comments: [shouldNotExceedCharLength(100)],
            },
        };
    },

    beforeMount() {
        this.isLoading = true;
        this.http
            .get(this.data.id)
            .then((response) => {
                const {data} = response.data;
                this.skill.name = data.skill.name;
                this.skill.comments = data.comments;
                this.skill.yearsOfExperience = data.yearsOfExperience;
            })
            .finally(() => {
                this.isLoading = false;
            });
    },

    methods: {
        onSave() {
            this.isLoading = true;
            this.http
                .update(this.data.id, {
                    yearsOfExperience: parseInt(this.skill.yearsOfExperience),
                    comments:
                        this.skill.comments !== '' ? this.skill.comments : '',
                })
                .then(() => {
                    return this.$toast.updateSuccess();
                })
                .then(() => {
                    this.onCancel();
                });
        },
        onCancel() {
            this.$emit('close', true);
        },
    },
};
</script>
